import React from 'react';
import {Link} from 'react-router';

type LinkProps = {
  to: string;
  size?: string;
  className?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

const sizeClasses = (size?: string) =>
  size === 'large' ? 'h-14 px-8' : 'px-6 py-2';

const makeLink =
  (colorClasses: string) =>
  ({size, className = '', children, to, ...props}: LinkProps) => {
    const classes = `inline-flex items-center justify-center rounded-full border font-medium cursor-pointer transition-colors ${sizeClasses(
      size,
    )} ${colorClasses} ${className}`;
    return (
      <Link to={to} className={classes} {...(props as object)}>
        {children}
      </Link>
    );
  };

const BasicLink = makeLink(
  'border-primary bg-white text-primary hover:bg-primary-light',
);
const PositiveLink = makeLink(
  'border-primary bg-primary text-white hover:bg-primary-hover',
);

export {BasicLink, PositiveLink};
